import tableConfig from '@/views/pages/tableConfig'

export default function config(moduleName, arg = {}) {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'full_name', label: 'Full name', sortable: true },
    { key: 'course', label: 'Course', sortable: true },
    { key: 'dc_type', label: 'Dc Type', sortable: true },
    { key: 'actions', label: '' },
  ]

  return {
    tableColumns,
    ...tableConfig(moduleName, arg),
  }
}
